import { render, staticRenderFns } from "./commonproblem.vue?vue&type=template&id=21729d4b&scoped=true"
var script = {}
import style0 from "./commonproblem.vue?vue&type=style&index=0&id=21729d4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21729d4b",
  null
  
)

export default component.exports